// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3RL1y","loadingShrink":"PageLoading_loadingShrink__2pJzY"};